require('@fontsource/barlow/400.css');
require('@fontsource/barlow-condensed/600.css');
require('@fontsource/barlow-condensed/700.css');
require('@fontsource/ibm-plex-mono/400.css');
require('./css/styles.scss');

// Moscow has used a fixed UTC+3 offset with no DST since 2014.
const MOSCOW_OFFSET_MS = 3 * 60 * 60 * 1000;

const refreshLocalTime = function () {
  const now = new Date();
  const localTimeEl = document.querySelector('#local-time');
  localTimeEl.textContent = now.toLocaleTimeString(undefined, {
    timeZone: 'Europe/Moscow',
    timeStyle: 'short',
  }) + ' local';
  localTimeEl.setAttribute(
    'datetime',
    new Date(now.getTime() + MOSCOW_OFFSET_MS).toISOString().slice(0, 19) + '+03:00'
  );
};

// show local time
setInterval(refreshLocalTime, 60 * 1000);
refreshLocalTime();
